import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

import { CslbLicenseService, IContact } from '@ebb-v2/ebb-integration';

import { ICslb, ICslbBusinessInfo, IContactInput } from '@ebb-v2/ebb-integration'
import { ContactApiService } from '../../data-services';

@Component({
  selector: 'ebb-portal-dialog-contractorunlisted',
  templateUrl: './dialog-contractorunlisted.component.html',
  styles: []
})
export class DialogContractorUnlistedComponent implements OnInit {
  public contractorData: ICslb;
  public contractorCoData: ICslbBusinessInfo;

  public formLicense: FormGroup;
  public formContact: FormGroup;
  public formMailing: FormGroup;
  public checkLicense = false;
  public invalidLicense = false;
  public invalidLicenseClassification = false;
  public invalidLicenseClassificationMsg = '';
  public disableSave = true;
  public disableNext1 = true;
  public disableNext2 = true;
  public disableLinear = true;
  public licensecheckdone = false;
  public iscontractorexists = false;
  public isExistcontractorData: IContact;
  public contractorLicenseSummary = '';
  public contractorContactInfoSummary = '';
  public contractMailingAddressSummary = '';

  constructor(
    public readonly dialogRef: MatDialogRef<DialogContractorUnlistedComponent>,
    private readonly fb: FormBuilder,
    private readonly apiCslbService: CslbLicenseService,
    private readonly apiContact: ContactApiService,
    
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit() {
    this.initializeForms();
  }

  private initializeForms() : void {
    this.formLicense = this.fb.group({
      contractorLicenseNumber: ['', [Validators.required]],
    });

    this.formContact = this.fb.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      emailAddress2: ['',
        [
          Validators.required,
          Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
        ]
      ],
      telephone1: ['', [Validators.required]],
      verifyinsuredbonded:[false, [Validators.required]]
      
    });

    this.formMailing = this.fb.group({
      sameAsBusinessAddress: '',
      address3_Line1: ['', [Validators.required]],
      address3_Line2: '',
      address3_City: ['', [Validators.required]],
      address3_StateOrProvince: ['', [Validators.required]],
      address3_PostalCode: ['', [Validators.required]]
    });
  }

  public onLookupLicenseNumber(): void {
    const checkNumber = this.formLicense.get('contractorLicenseNumber').value;

    this.checkLicense = true;
    this.contractorData = null;
    this.contractorCoData = null;
    this.isExistcontractorData =null;
    this.iscontractorexists = false;
    this.invalidLicenseClassification = false;
          this.invalidLicenseClassificationMsg = "";
          this.apiCslbService
          .getcslbLicense(checkNumber)
          .subscribe(
            data => {
              //console.log(`Return: ${JSON.stringify(data)}`)
              const licenseIsValid = data.isValid;
              if ( !licenseIsValid) {
                this.invalidLicense = true;
                this.checkLicense = false;
                this.invalidLicenseClassificationMsg = data.errormessage;
                this.disableNext1 = true;
                this.formContact.disable();
                this.formMailing.disable();
            
              }
              if ( licenseIsValid ) {
                if ( data.classifications.includes('A') || data.classifications.includes('B') ) {
                  this.invalidLicense = false;
                  this.contractorData = data;
                  this.contractorCoData = data.businessInfo;
                  this.contractorLicenseSummary = `- ${this.contractorCoData.name}`
                  this.setDefaultValues();
                  this.invalidLicenseClassification = false;
                  this.disableNext1 = false;
                  this.disableLinear = false;
                  this.disableSave = false;                 
                  this.apiContact.checkContractorLicense(checkNumber).subscribe(
                    existingContractorUsingLicense => {
              if(existingContractorUsingLicense == null){
                this.licensecheckdone = true;
                this.formContact.enable();
                this.formMailing.enable();
                } else {
                      this.isExistcontractorData =existingContractorUsingLicense;
                   
                      this.iscontractorexists = true;
                      this.invalidLicense = true;
                      this.checkLicense = false;
                      this.disableNext1 = true;
                      this.licensecheckdone = false;
                      this.formContact.disable();
                      this.formMailing.disable();
                       }
                
                    }, error => {
                      console.warn(`ERROR: getCheckLicenseExists() or getContactExists() - ${error}`);
                    });
                  
                } else {
                  this.invalidLicenseClassification = true;
                  this.invalidLicenseClassificationMsg = data.errormessage;
                  this.invalidLicense = true;
                  this.disableNext1 = true;
                }
                this.checkLicense = false;
              }
            },
          error => console.warn(`ERROR: Unable to validate license number`)
          );
    

   
  }

  public displayLicenseExpiration(): string {
    const newDateString = this.contractorData.expirationDate.toString();
    const newDateOnly = new Date(newDateString); 
    return newDateOnly.toLocaleDateString('en-US');
  }

  private setDefaultValues(): void {
    if (this.contractorCoData.businessPhoneNum &&
        this.contractorCoData.businessPhoneNum.length > 0) {
      this.formContact.get('telephone1').setValue(this.contractorCoData.businessPhoneNum);
    }
  }

  public setContractorContactInfoSummary(): void {
    const fullName = `${this.formContact.get('firstName').value} ${this.formContact.get('lastName').value}`;
    this.contractorContactInfoSummary = `- ${fullName}`;
  }

  public onCheckSameAsBusinessAddress(event): void {
    if(this.contractorCoData) {
      if (event.checked) {
        this.formMailing.get('address3_Line1').setValue(this.contractorCoData.addr1);
        this.formMailing.get('address3_Line2').setValue(this.contractorCoData.addr2);
        this.formMailing.get('address3_City').setValue(this.contractorCoData.city);
        this.formMailing.get('address3_StateOrProvince').setValue(this.contractorCoData.state);
        this.formMailing.get('address3_PostalCode').setValue(this.contractorCoData.zip);

        this.formMailing.get('address3_Line1').disable();
        this.formMailing.get('address3_Line2').disable();
        this.formMailing.get('address3_City').disable();
        this.formMailing.get('address3_StateOrProvince').disable();
        this.formMailing.get('address3_PostalCode').disable();


      } else {
        this.formMailing.get('address3_Line1').setValue('');
        this.formMailing.get('address3_Line2').setValue('');
        this.formMailing.get('address3_City').setValue('');
        this.formMailing.get('address3_StateOrProvince').setValue('');
        this.formMailing.get('address3_PostalCode').setValue('');
        this.formMailing.get('address3_Line1').enable();
        this.formMailing.get('address3_Line2').enable();
        this.formMailing.get('address3_City').enable();
        this.formMailing.get('address3_StateOrProvince').enable();
        this.formMailing.get('address3_PostalCode').enable();
      }
    }
  }

  public onCheckFormLicenseControlValidators(controlName: string): boolean {
    const retVal = (this.formLicense.get(controlName).errors
                      && (this.formLicense.get(controlName).dirty || this.formLicense.get(controlName).touched));
    return retVal;
  }

  public onCheckFormContactControlValidators(controlName: string): boolean {
    const retVal = (this.formContact.get(controlName).errors
                      && (this.formContact.get(controlName).dirty || this.formContact.get(controlName).touched));
    return retVal;
  }

  public onCheckFormMailingControlValidators(controlName: string): boolean {
    const retVal = (this.formMailing.get(controlName).errors
                      && (this.formMailing.get(controlName).dirty || this.formMailing.get(controlName).touched));
    return retVal;
  }

  public onCheckFormContactControlLengthHint(controlName: string, length: number): boolean {
    return this.formContact.get(controlName).value && this.formContact.get(controlName).value.length >= length;
  }

  public onCheckFormLicenseControlLengthHint(controlName: string, length: number): boolean {
    return this.formLicense.get(controlName).value && this.formLicense.get(controlName).value.length >= length;
  }

  public onCheckFormMailingControlLengthHint(controlName: string, length: number): boolean {
    return this.formMailing.get(controlName).value && this.formMailing.get(controlName).value.length >= length;
  }

  public onClickClose(): void {
    this.dialogRef.close();
  }
  public onExistingContractorSelect(): void{
     var data ={} as any;
    data.contact = this.isExistcontractorData;
    data.isexists = true;
    data.contactInput =null;
    this.dialogRef.close(data);
  }

  public onSave(): void {
    const newContact: IContactInput = {} as IContactInput;

    newContact.firstName = this.formContact.get('firstName').value;
    newContact.lastName = this.formContact.get('lastName').value;
    newContact.emailAddress1 = this.formContact.get('emailAddress2').value;
    newContact.telephone1 = this.formContact.get('telephone1').value;

    newContact.contractorLicenseNumber = this.contractorData.licNum;
    newContact.contractorLicenseExpiration = this.contractorData.expirationDate;

    if ( this.contractorData.classifications.includes('A') &&
         this.contractorData.classifications.includes('B') ) {
          newContact.contractorLicenseType = '700000000,700000001';
    } else if (this.contractorData.classifications.includes('A')) {
      newContact.contractorLicenseType = '700000000';
    } else {
      newContact.contractorLicenseType = '700000001';
    }
   var verifyinsuredbonded = this.formContact.get('verifyinsuredbonded').value
    newContact.insured = verifyinsuredbonded;
    newContact.bonded = verifyinsuredbonded;

    newContact.contactType = '700000005';
    newContact.contractorInDirectory = false;
    newContact.contractorManualEntry = true;

    newContact.businessName = this.contractorCoData.name;

    newContact.address2_Line1 = this.contractorCoData.addr1;
    newContact.address2_Line2 = this.contractorCoData.addr2;
    newContact.address2_City = this.contractorCoData.city;
    newContact.address2_StateOrProvince = this.contractorCoData.state;
    newContact.address2_PostalCode = this.contractorCoData.zip;
    var sameAsBusinessAddress = this.formMailing.get('sameAsBusinessAddress').value
    if(sameAsBusinessAddress ===true){
    newContact.isSameas_BusinessAddress =  sameAsBusinessAddress}
    newContact.address3_Line1 = this.formMailing.get('address3_Line1').value;
    newContact.address3_Line2 = this.formMailing.get('address3_Line2').value;
    newContact.address3_City = this.formMailing.get('address3_City').value;
    newContact.address3_StateOrProvince = this.formMailing.get('address3_StateOrProvince').value;
    newContact.address3_PostalCode = this.formMailing.get('address3_PostalCode').value;
    var data ={} as any;

    data.contact = null;
    data.isexists = false;
    data.contactInput =newContact;
    this.dialogRef.close(data);
  }
  public formatLink(value: string) {
    if (value) {
      value = value.toLowerCase();
      if (value.startsWith('http')) {
        return value;
      } else {
        return `http://${value}`;
      }
    }
    return '';
  }
}